import React, { FC, memo } from 'react';

import { HStack } from '@rbilabs/universal-components';

import { VisuallyHidden } from 'components/ucl/visually-hidden';

import { RedeemRewardActionButton } from './redeem-reward-action';
import { IRedeemRewardViewProps, RewardActions } from './types';

export const RedeemRewardView: FC<React.PropsWithChildren<IRedeemRewardViewProps>> = ({
  onRewardAdd,
  onRewardRemove,
  points,
  rewardTitle,
  isRewardApplied,
  disableApplyButton,
  itemQuantity,
  incentiveNotInMenu,
  redeemRewardLoading,
}) => {
  const RenderRewardButton = memo(
    ({ action, isDisabled }: { action: RewardActions; isDisabled: boolean }) => (
      <RedeemRewardActionButton
        disabled={isDisabled || redeemRewardLoading}
        action={action}
        onRewardAdd={onRewardAdd}
        onRewardRemove={onRewardRemove}
        points={points}
        loading={redeemRewardLoading}
      />
    )
  );

  const displayApplyButton = itemQuantity > 1 || !isRewardApplied;
  const displayActionButtons = !incentiveNotInMenu;

  return (
    <>
      {displayActionButtons && (
        <HStack>
          {displayApplyButton && (
            <RenderRewardButton action={RewardActions.ADD} isDisabled={disableApplyButton} />
          )}
          {isRewardApplied && (
            <RenderRewardButton action={RewardActions.REMOVE} isDisabled={!isRewardApplied} />
          )}
        </HStack>
      )}
      <VisuallyHidden accessibilityLabel={rewardTitle} />
    </>
  );
};
